import { render, staticRenderFns } from "./KitsRelatedToProduct.vue?vue&type=template&id=5cd0db04"
import script from "./KitsRelatedToProduct.vue?vue&type=script&lang=js"
export * from "./KitsRelatedToProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports